var parent = require('../../stable/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/keys.js
// module id = 3512
// module chunks = 25